"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
exports.__esModule = true;
exports.default = void 0;
var _pattern = _interopRequireDefault(require("./pattern.js"));
var _holder = _interopRequireDefault(require("../core/holder.js"));
var _changeDetails = _interopRequireDefault(require("../core/change-details.js"));
var _utils = require("../core/utils.js");
var _continuousTailDetails = _interopRequireDefault(require("../core/continuous-tail-details.js"));
require("./base.js");
require("./factory.js");
require("./pattern/chunk-tail-details.js");
require("./pattern/cursor.js");
require("./pattern/fixed-definition.js");
require("./pattern/input-definition.js");
require("./regexp.js");
var _excluded = ["enum"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/** Pattern which validates enum values */
var MaskedEnum = exports.default = /*#__PURE__*/function (_MaskedPattern) {
  function MaskedEnum(opts) {
    _classCallCheck(this, MaskedEnum);
    return _callSuper(this, MaskedEnum, [_objectSpread(_objectSpread({}, MaskedEnum.DEFAULTS), opts)]); // mask will be created in _update
  }
  _inherits(MaskedEnum, _MaskedPattern);
  return _createClass(MaskedEnum, [{
    key: "updateOptions",
    value: function updateOptions(opts) {
      _superPropGet(MaskedEnum, "updateOptions", this, 3)([opts]);
    }
  }, {
    key: "_update",
    value: function _update(opts) {
      var enum_ = opts.enum,
        eopts = _objectWithoutProperties(opts, _excluded);
      if (enum_) {
        var lengths = enum_.map(function (e) {
          return e.length;
        });
        var requiredLength = Math.min.apply(Math, _toConsumableArray(lengths));
        var optionalLength = Math.max.apply(Math, _toConsumableArray(lengths)) - requiredLength;
        eopts.mask = '*'.repeat(requiredLength);
        if (optionalLength) eopts.mask += '[' + '*'.repeat(optionalLength) + ']';
        this.enum = enum_;
      }
      _superPropGet(MaskedEnum, "_update", this, 3)([eopts]);
    }
  }, {
    key: "_appendCharRaw",
    value: function _appendCharRaw(ch, flags) {
      var _this = this;
      if (flags === void 0) {
        flags = {};
      }
      var matchFrom = Math.min(this.nearestInputPos(0, _utils.DIRECTION.FORCE_RIGHT), this.value.length);
      var matches = this.enum.filter(function (e) {
        return _this.matchValue(e, _this.unmaskedValue + ch, matchFrom);
      });
      if (matches.length) {
        if (matches.length === 1) {
          this._forEachBlocksInRange(0, this.value.length, function (b, bi) {
            var mch = matches[0][bi];
            if (bi >= _this.value.length || mch === b.value) return;
            b.reset();
            b._appendChar(mch, flags);
          });
        }
        var d = _superPropGet(MaskedEnum, "_appendCharRaw", this, 3)([matches[0][this.value.length], flags]);
        if (matches.length === 1) {
          matches[0].slice(this.unmaskedValue.length).split('').forEach(function (mch) {
            return d.aggregate(_superPropGet(MaskedEnum, "_appendCharRaw", _this, 3)([mch]));
          });
        }
        return d;
      }
      return new _changeDetails.default({
        skip: !this.isComplete
      });
    }
  }, {
    key: "extractTail",
    value: function extractTail(fromPos, toPos) {
      if (fromPos === void 0) {
        fromPos = 0;
      }
      if (toPos === void 0) {
        toPos = this.displayValue.length;
      }
      // just drop tail
      return new _continuousTailDetails.default('', fromPos);
    }
  }, {
    key: "remove",
    value: function remove(fromPos, toPos) {
      var _this2 = this;
      if (fromPos === void 0) {
        fromPos = 0;
      }
      if (toPos === void 0) {
        toPos = this.displayValue.length;
      }
      if (fromPos === toPos) return new _changeDetails.default();
      var matchFrom = Math.min(_superPropGet(MaskedEnum, "nearestInputPos", this, 3)([0, _utils.DIRECTION.FORCE_RIGHT]), this.value.length);
      var pos;
      for (pos = fromPos; pos >= 0; --pos) {
        var matches = this.enum.filter(function (e) {
          return _this2.matchValue(e, _this2.value.slice(matchFrom, pos), matchFrom);
        });
        if (matches.length > 1) break;
      }
      var details = _superPropGet(MaskedEnum, "remove", this, 3)([pos, toPos]);
      details.tailShift += pos - fromPos;
      return details;
    }
  }, {
    key: "isComplete",
    get: function get() {
      return this.enum.indexOf(this.value) >= 0;
    }
  }]);
}(_pattern.default);
/** Match enum value */
MaskedEnum.DEFAULTS = _objectSpread(_objectSpread({}, _pattern.default.DEFAULTS), {}, {
  matchValue: function matchValue(estr, istr, matchFrom) {
    return estr.indexOf(istr, matchFrom) === matchFrom;
  }
});
_holder.default.MaskedEnum = MaskedEnum;